import { useContext, useEffect, useRef } from "react";
import {
  getOwnerData,
  getHolderData,
} from "../../services/login/login.service";
import { formatOwnerData } from "../../../utils/ownerData/ownerData.util";
import { GetCifCupsRequestBody } from "../../models/cupsCifSelector/cupsCifSelector.model";
import TotalEnergiesContext from "../../store/context/TotalEnergiesContext";
import {
  clearFirstLoadCifCups,
  formatCifCups,
  initialCifCupsState,
  newLoadCipCups,
} from "../../../utils/components/cupsCifSelector/cupsCifSelector.util";
import { getCifCups } from "../../services/cupsCifSelector/cupsCifSelector.service";
import { OwnerDataCups } from "../../models/ownerData/ownerData.model";
import { useNavigate } from "react-router-dom";

const useOwnerData = () => {
  const { storageOwnerData, storageCifCupsState, ownerData, setIsAgent } =
    useContext(TotalEnergiesContext);

  const hasLoadedRef = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    // If already loaded or if ownerData already exists, do not execute again
    if (hasLoadedRef.current || ownerData) {
      return;
    }

    hasLoadedRef.current = true;
    let cups!: OwnerDataCups[];

    const storedHolderData = localStorage.getItem("holderData");
    if (!storedHolderData) {
      getHolderData(undefined, "")
        .then((holderDataResult) => {
          const isAgent = holderDataResult?.flags?.EsAgente || false;

          if (isAgent) {
            // Si es agente: actualizamos contexto y evitamos cargar ownerData
            console.log("Usuario es agente, saltando getOwnerData");
            setIsAgent(true);
            navigate(process.env.REACT_APP_MANAGEMENT!);
            return Promise.reject({ skipError: true });
          }

          return getOwnerData(undefined, "");
        })
        .then((response) => {
          const {
            isAdministrator,
            idAdministrator,
            idClient,
            cups: cupsOwnerData,
          } = formatOwnerData(response);
          const getManagementsCifCupsRequestBody: GetCifCupsRequestBody = {
            userid: isAdministrator ? idAdministrator : idClient,
            isAdmin: isAdministrator,
          };
          cups = cupsOwnerData;
          storageOwnerData(response);
          storageCifCupsState(newLoadCipCups(initialCifCupsState, true));

          return getCifCups(getManagementsCifCupsRequestBody, "");
        })
        .then((cifCupsRaw) => {
          const formattedCifCups = formatCifCups(cifCupsRaw, cups);
          storageCifCupsState(clearFirstLoadCifCups(formattedCifCups));
        })
        .catch((error) => {
          if (error?.skipError) {
            // Controlled error for agent users
            return;
          }
          console.error("Error in useOwnerData:", error);
          hasLoadedRef.current = false;
        });
    }
  }, [ownerData, storageCifCupsState, storageOwnerData, navigate, setIsAgent]);
};

export default useOwnerData;
